import React, { useState, useEffect, useRef } from 'react';

export default function Skill(props){
    const [checked, setChecked] = useState(props.isChecked);
    function handleCheckboxChange(value) {
        if(value){
            props.add(props.skill);
        }else{
            props.remove(props.skill);
        }
        setChecked(value);
    }

    useEffect(() => {
        handleCheckboxChange(props.isChecked);
    }, [props.isChecked])

    return(
        <>
            <label key={props.index} className="flex items-center">
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => handleCheckboxChange(e.target.checked)}
                    className='max-[900px]:mb-5 align-text-middle'  
                />
                <span className='mleft--10'>
                    {props.skill.text}
                </span>
            </label>
        </>
    )
}